import React, {useState} from "react";
import AGButton from "../../../components/Button";
import AGModalComfirmModal from "../../../components/ComfirmModal";
import {default as AGTextarea} from "../../../components/Textarea";
import {AGModalWraper} from "./approveModal.styled";
import AGModal from "../../../components/Modal";

export interface RejectConfirmModalProps {
  visible: boolean;
  toggleModal: () => void;
  rejectService: (reason: string) => void; // Truyền lý do reject
  zIndex?: number;
  tab?: string;
  isHeightMobile: boolean;
}

const RejectConfirmModal = ({
  visible,
  toggleModal,
  rejectService,
  zIndex,
  isHeightMobile,
  tab,
}: RejectConfirmModalProps) => {
  const [rejectReason, setRejectReason] = useState<string>("");

  return (
    <AGModal
      toggleModal={()=>{
        toggleModal();
        setRejectReason("");
      }}
      title={tab === "service" ? "Reject Service" : "Reject Product"}
      footer={
        <>
          <AGButton
            type="Primary"
            disabled={!rejectReason.trim()}
            onClick={() => {
              rejectService(rejectReason);
              setRejectReason("");
            }}
          >
            Reject
          </AGButton>
          <AGButton
            type="Secondary"
            onClick={toggleModal}
          >
            Cancel
          </AGButton>
        </>
      }
      visible={visible}
      setHeight={isHeightMobile ? undefined : 330}
    >
      <AGModalWraper className="w-full">
        <div style={{padding: 20}}>
          Are you sure you want to reject this {tab === "service" ? "service" : "product"}?
        </div>

        <div className="w-full px-[20px] pb-[20px]">
          <label
            className="label-title"
            htmlFor=""
          >
            Rejection reason: <span className="required">*</span>
          </label>
          <AGTextarea
            style={{height: "90px", resize: "none"}}
            maxLength={150}
            placeholder=""
            className="text-area"
            value={rejectReason ?? undefined}
            onChange={(e) => {
              setRejectReason(e.target.value);
            }}
          />
        </div>
      </AGModalWraper>
    </AGModal>
  );
};

export default RejectConfirmModal;
